import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {TermsModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function getTermsByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<TermsModel>>(`${BASEURL}/terms/getTermsById`, {
    params: {
      Id: id,
    },
  })
}
